import type { RegionCode } from "@/types";

/** Mirrors backend `REGION_IANA_TIMEZONES` in `app.utils.activity_timezone`. */
export const REGION_IANA_TIMEZONES: Record<RegionCode, string> = {
  IT: "Europe/Rome",
  ES: "Atlantic/Canary",
};

export function ianaTimezoneForRegionCode(
  regionCode: RegionCode | null,
): string | null {
  if (regionCode === null) {
    return null;
  }
  return REGION_IANA_TIMEZONES[regionCode] ?? null;
}

export function partValue(
  parts: Intl.DateTimeFormatPart[],
  type: Intl.DateTimeFormatPartTypes,
): string {
  return parts.find((part) => part.type === type)?.value ?? "";
}

/** IANA zone from the runtime (falls back to UTC when unavailable). */
export function browserIanaTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
}

/** `YYYY-MM-DD` civil date for an instant in a specific IANA zone. */
export function calendarDateKeyInTimeZone(date: Date, timeZone: string): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  return `${partValue(parts, "year")}-${partValue(parts, "month")}-${partValue(parts, "day")}`;
}
